import { get } from 'lodash-es';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { dateInitFormats, parseCustomFormatToDate } from '@common/Util';

const Timepicker = ({
  field = {},
  form: { touched, errors } = {},
  required = false,
  isManualInputDisabled = false,
  onChange = () => {},
  ...rest
}) => {
  const isError = Boolean(get(touched, field?.name) && get(errors, field?.name));
  const errorMsg = get(touched, field?.name) && get(errors, field?.name);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        inputFormat={dateInitFormats.time}
        slotProps={{
          openPickerIcon: {
            color: 'primary'
          },
          textField: (props) => ({
            onBlur: field?.onBlur,
            required: required,
            name: field?.name,
            size: 'small',
            error: isError,
            helperText: errorMsg,
            InputProps: { ...props.inputProps, ...props.InputProps },
            onKeyDown: (e) => {
              isManualInputDisabled && e.preventDefault();
            }
          })
        }}
        {...rest}
        onChange={onChange}
        value={parseCustomFormatToDate(field?.value || rest?.value, [
          dateInitFormats.time,
          dateInitFormats.timeLong
        ])}
      />
    </LocalizationProvider>
  );
};

export default Timepicker;
